<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      title="详情 余额修改"
      id-key="BalanceChangeId"
      :save-func="api.save"
      :form-rules="rules"
      close-on-saved
      :show-save-button="isEdit"
      :data="data"
      @closed="$emit('close-saved')"
      @details-opened="onDetailsOpened"
      @create-opened="onCreateOpened"
      @close="onClose"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="单号">
              <span>{{ data.OrderNo }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称">
              <customer
                @restaurants="setSupplier"
                :state="data.CustomerName"
                v-if="isEdit"
              />
              <span v-else>{{ data.CustomerName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原余额">
              <span>{{ data.OriginalBalance }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="余额">
              <el-input
                v-model="data.Balance"
                placeholder="请输入修改余额"
                type="number"
                @blur="checkNum"
                v-if="isEdit"
              ></el-input>
              <span v-else>{{ data.Balance }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!isEdit">
          <el-col :span="12">
            <el-form-item label="支付时间">
              <span>{{ this.$commonJs.toDateString(data.AddTime) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input v-model="data.Remark" v-if="isEdit"></el-input>
              <span v-else>{{ data.Remark }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button
          size="mini"
          type="success"
          @click="review(1)"
          v-if="!isEdit && data.Status == 0"
          >通 过</el-button
        >
        <el-button
          size="mini"
          type="danger"
          @click="review(2)"
          v-if="!isEdit && data.Status == 0"
          >不通过</el-button
        >
        <el-button size="mini" v-if="!isEdit" @click="close">取 消</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import customer from "@/components/common/customer/customer";
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [detailsDialogMixin],
  components: {
    commonDialog,
    customer,
  },
  data() {
    return {
      isEdit: false,
      data: {
        BalanceChangeId: 0,
        OrderNo: "",
        CustomerId: 0,
        CustomerName: "",
        OriginalBalance: 0,
        Balance: 0,
        Status: 0,
        Remark: "",
        AddTime: null,
      },
      api: require("@/api/sy/balanceChange").default,
      billApi: require("@/api/sy/bill").default,
      rules: {
        CustomerId: [{ required: true, message: "客户不能为空" }]
      },
    };
  },
  computed: {},
  methods: {
    onDetailsOpened(row) {
      console.log("onOpened", row);
      console.log("onOpened-data", this.data);
      console.log("isEdit", this.isEdit);
    },
    onCreateOpened(data) {
      this.isEdit = true;
      this.billApi.getDefaultSerialNo("余额修改单").then((res) => {
        if (res.Code == 0 && res.Data) {
          this.data.OrderNo = res.Data;
        } else {
          this.$message.warning(res.Msg);
        }
      });
    },
    setSupplier(data) {
      console.log("setSupplier", data);
      this.data.CustomerId = data.TradeUnitId;
      this.data.CustomerName = data.TradeUnitName;
      this.data.OriginalBalance = data.Balance;
    },
    review(status) {
      this.$refs.dialog.$refs.form
        .validate()
        .then((valid) => {
          if (!valid) return;
          this.data.Status = status;
          this.$refs.dialog.isLoading = true;
          this.api.review(this.data).then((res) => {
            this.$refs.dialog.isLoading = false;
            if (res.Code == 0)
              this.$message.success("审核成功"), this.$emit("close-saved");
            else this.$message.error("审核失败");
          });
        })
        .catch(() => {});
    },
    checkNum() {
      if (!(this.data.Balance > 0)) {
        this.data.Balance = 0;
      }
    },
    onClose() {
      this.isEdit = false;
    },
  },
};
</script>
